"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var BORING_IMAGES = [
    "photo-1432256851563-20155d0b7a39.jpg",
    "photo-1444837881208-4d46d5c1f127.jpg",
    "photo-1438480478735-3234e63615bb.jpg",
    "photo-1437823055869-5309288494c8.jpg",
    "photo-1435771112039-1e5b2bcad966.jpg",
    "photo-1438115234772-f94147ca89b7.jpg",
    "photo-1422189668989-08f214d6e419.jpg",
    "photo-1428908728789-d2de25dbd4e2.jpg",
];
var StockImagesService = (function () {
    function StockImagesService(imageLocation) {
        this.imageLocation = imageLocation;
    }
    StockImagesService.prototype.getStockImages = function (page, perPage) {
        return __awaiter(this, void 0, Promise, function () {
            var startIndex, endIndex;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.lazyFetchImagesList()];
                    case 1:
                        _a.sent();
                        startIndex = page * perPage;
                        endIndex = startIndex + perPage;
                        return [2, this.imageList
                                .slice(startIndex, endIndex)
                                .map(function (fileName, index) { return _this.toImage((startIndex + index).toString(), fileName); })];
                }
            });
        });
    };
    StockImagesService.prototype.getRandomImage = function () {
        return __awaiter(this, arguments, Promise, function (_a) {
            var imageList, randomIndex, fileName;
            var _b = _a === void 0 ? {} : _a, _c = _b.preventBoringImages, preventBoringImages = _c === void 0 ? false : _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4, this.lazyFetchImagesList()];
                    case 1:
                        _d.sent();
                        imageList = this.imageList;
                        if (preventBoringImages) {
                            imageList = lodash_1.without.apply(void 0, __spreadArray([imageList], __read(BORING_IMAGES), false));
                        }
                        randomIndex = Math.floor(Math.random() * imageList.length);
                        fileName = imageList[randomIndex];
                        return [2, this.toImage(randomIndex.toString(), fileName)];
                }
            });
        });
    };
    StockImagesService.prototype.lazyFetchImagesList = function () {
        return __awaiter(this, void 0, Promise, function () {
            var jsonFilePath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.imageList) return [3, 2];
                        jsonFilePath = this.imageLocation.local("data/StockImages.json");
                        return [4, axios_1.default.get(jsonFilePath)];
                    case 1:
                        response = _a.sent();
                        this.imageList = response.data.images;
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    StockImagesService.prototype.toImage = function (id, fileName) {
        return {
            id: id,
            url: this.imageLocation.stockImageLarge(fileName),
            thumbnailUrl: this.imageLocation.stockImageSmall(fileName),
        };
    };
    return StockImagesService;
}());
exports.default = StockImagesService;
